import { StepperSummaryDescriptor } from "./StepperSummaryDescriptor"
import { StepperStepDescriptor } from "./StepperStepDescriptor"
import Link from '../../../models/Link'

export enum StepperOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export type StepperDescriptor = {
  id: number
  name: string
  orientation: StepperOrientation
  complete: boolean
  summary: StepperSummaryDescriptor | null
  steps: StepperStepDescriptor[]
  links: Link[]
}
